<div *ngIf="data && !reviewOpened" class="laptop_padding w_100 single_page_container mt_35">
  <ng-container *ngIf="isBrowser">
    <div class="navigate_and_share_container flex_between_align_center font_15 bold_600" *ngIf="!isMobile">
      <div class="flex_align_center">
        <div class="navigate_back flex_align_center pointer" (click)="goBack()">
          <img src="assets/images/icons/chevron-right.svg">
          <span class="navigate_back--text">
            {{'product.single_page.go_back' | translate}}
          </span>
        </div>
        <div class="ml_20">
          <app-navigation
            [navigationData]="navigationData"
          ></app-navigation>
        </div>
      </div>
      <div class="share_and_like_container">
        <div class="flex_center_align_center pointer" (click)="copyPathForShare()">
          <img src="assets/images/icons/product_single/share.svg">
          <span class="ml_8">
        {{ 'product.single_page.share' | translate }}
      </span>
        </div>
        <div class="flex_center_align_center pointer">
          <app-add-to-favorites-button
            [id]="data.id"
            [type]="addToFavoriteTypeEnum.PRODUCT"
            [liked]="data.liked"
            (favoriteChangeEventEmitter)="data.liked = $event"
          >
          </app-add-to-favorites-button>
          <span class="ml_8">
        {{ 'product.single_page.add_to_favorites' | translate }}
      </span>
        </div>
      </div>
    </div>
    <div class="images_of_flower laptop_margin position_relative" *ngIf="isMobile">
      <app-custom-slider *ngIf="data?.resourceUrls" (click)="openGallery()">
        <div *ngFor="let item of data.resourceUrls;let i = index" class="h_100 items pointer">
          <div class="card_container position_relative flex_column br_20 flow_hide"
               [ngClass]="{'full_width':data.resourceUrls.length === 1}">
            <img [src]="item.resourceUrl">
          </div>
        </div>
      </app-custom-slider>
    </div>
  </ng-container>
  <div class="single_product_block">
    <div class="flower_details">
      <div class="flower_image flex w_100" *ngIf="!isMobile">
        <app-vertical-swiper *ngIf="isBrowser"
                             (click)="openGallery()"
                             [data]="data.resourceUrls"
        >
        </app-vertical-swiper>
        <div class="flower_slider_container">
          <app-product-gallery
            [img_data]="data.resourceUrls"
            [type]="swiperTypeEnum"
            (click)="openGallery()"
          >
          </app-product-gallery>
        </div>
      </div>
      <div class="flower_info w_100">
        <h1 style="visibility: hidden" *ngIf="!isBrowser">{{data.title}}</h1>

        <div class="title_and_rate text_title_middle bold_800" [ngClass]="{'pl_pr_16':isMobile}">
          <div class="mb_12 name">{{ data.title }}</div>
          <div class="flex_align_center product_rating">
            <img src="assets/images/icons/shops/star_for_shop.svg">
            <div class="rating_number ml_8">
              {{data.productAverageRate  | number: '0.2-2' | replaceToComma}}
            </div>
            <div class="rate_count ml_12">
              {{ data.rateCount }} оценок товара
            </div>
          </div>
        </div>
        <div class="flex_between_align_center photos pointer" *ngIf="reviewImages.length"
          (click)="openReviews()"
        >
          <div class="gallery">
            <div class="image-wrapper" [ngClass]="{
                  'margin_unset' : i === 0, last: (reviewImages.length > 5 && reviewImages.length - 1)
               }"
                 *ngFor="let img of reviewImages; let i = index"
            >
              <img [src]="img" />

              <div class="overlay" *ngIf="reviewImages.length > 5">
                +{{ data.rateResourcesCount }}
              </div>
            </div>
          </div>
          <img src="assets/images/icons/chevron-right.svg">
        </div>

        <div class="price_and_delivery_for_tablet">
          <div class="flex_between_align_center">
            <div class="price_and_sale">
              <div class="price">
                {{ (data.price | priceSpaces) + "₽" }}
              </div>
              <!--                <div class="sale_price">-->
              <!--                  6 410 ₽-->
              <!--                </div>-->
              <!--                <div class="sale">-->
              <!--                  -67%-->
              <!--                </div>-->
            </div>
            <app-bonus-display *ngIf="data.bonusAmount"
                               [bonus]="data.bonusAmount"
            ></app-bonus-display>
          </div>
          <div class="delivery_price_and_time">
              <span class="gray_text">
                Доставим за
              </span>
            <span class="bold">
                ~ {{data.shop.averageDeliveryTime | millisecondsToMinutes}} минут,{{data.minimalDeliveryPrice}}₽
              </span>
          </div>
        </div>

        <div class="description_container" [ngClass]="{'pl_pr_16':isMobile}">
          <div class="mb_20">
              <span class="font_14 text_gray_color">
                {{ 'product.single_page.product_description' | translate }}
              </span>
            <div class="mt_4 font_14">
              {{ data.description || '' }}
            </div>
          </div>
          <div class="composition_of_the_bouquet mb_20">
              <span class="font_14 text_gray_color">
                {{ 'product.single_page.compound' | translate }}:
              </span>
            <div class="mt_8">
                <span class="font_14" *ngFor="let flower of data.composition;let i =index">
                  {{ (flower?.name || '') | titlecase }} - {{ flower?.count || '' }} шт
                  {{ i === data.composition.length - 1 ? '' : ',' }}
                </span>
            </div>
          </div>
          <div class="dimensions" *ngIf="isMobile">
              <span class="font_13 bold_600 text_gray_color">
                {{ 'product.single_page.dimensions' | translate }}:
              </span>
            <div class="font_15 bold font_color mt_8">
              <span *ngIf="data.height">
                {{ 'product.single_page.width' | translate }} - {{ data.width || '' }} см.
              </span>
              <span *ngIf="data.height">
               , {{ 'product.single_page.height' | translate }} - {{ data.height || '' }} см.
              </span>
            </div>
          </div>

        </div>

        <div class="shop_info_container w_100 flex_between_align_center">
          <div class="price_and_buy_block_for_tablet">

            <div class="flex_align_center mt_28">
              <div class="camera_block">
                <img src="assets/images/icons/product_single/Desc.png">
              </div>
              <div class="ml_16 bold_600 font_14">
                Отправим видео с вашим товаром
                перед доставкой
              </div>
            </div>
            <div class="add_basket_buttons">
              <button class="add_basket pointer" *ngIf="!data.countInBasket" (click)="addToBasket($event)">
                {{ 'product.single_page.add_to_basket' | translate }}
              </button>
              <app-add-and-reduce *ngIf="data.countInBasket && !isMobile"
                                  [productCard]="data"
                                  [type]="addAndReduceTypeEnums.SINGLE_PAGE">
              </app-add-and-reduce>
              <button class="buy_in_one_click pointer" (click)="addToBasket($event, true)">
                {{ 'product.single_page.buy_in_one_click' | translate }}
              </button>
            </div>
          </div>

          <div>
            <div class="shop_view flex_between_align_center pointer" (click)="filterProductsByShop()">
              <div class="shop_info flex_align_center">
                <div class="shop_logo" [ngClass]="{'default_image flex_center_align_center':!data.shop.imageUrl}">
                  <img [src]="data.shop.imageUrl || 'assets/images/icons/shops/shop-default.svg'"
                       [ngClass]="{'logo_img':data.shop.imageUrl}">
                </div>
                <div class="flex_column ml_12">
                  <span class="text_normal_sub bold_700">
                    {{ data.shop.shopName }}
                  </span>
                  <span class="shop_description">
                    {{ data.shop?.description }}
                  </span>
                </div>
              </div>
            </div>
            <div class="flex_align_center mt_12 block_rat">
              <div class="flex_align_center rating_number">
                <img src="assets/images/icons/shops/star_for_shop.svg">
                <div class="number ml_4">
                  {{data.shop.shopAverageRate | number: '0.2-2' | replaceToComma}}
                </div>
              </div>
              <div class="pay_bonus">
                <div class="pay_bonus--text">
                  Оплата баллами {{data.shop.bonusDeduction}}%
                </div>
                <img class="ml_4" src="assets/images/icons/shops/bonus_icon_for_shop_details.svg">
              </div>
              <!--                <div class="cashback">-->
              <!--                  % Кэшбек 40%-->
              <!--                </div>-->
            </div>
          </div>
          <img class="arrow_right_tablet" src="assets/images/icons/chevron-right.svg">
        </div>

      </div>
      <div class="price_and_buy_block">
        <div class="flex_between_align_center">
          <div class="price_and_sale">
            <div class="price">
              {{ (data.price | priceSpaces) + "₽" }}
            </div>
          </div>
          <app-bonus-display *ngIf="data.bonusAmount"
                             [bonus]="data.bonusAmount"
          ></app-bonus-display>
        </div>
        <div class="delivery_price_and_time">
          <span class="gray_text">
            Доставим за
          </span>
          <span class="bold">
            ~ {{data.shop.averageDeliveryTime | millisecondsToMinutes}} минут,{{data.minimalDeliveryPrice}}₽
          </span>
        </div>
        <div class="flex_align_center mt_28">
          <div class="camera_block">
            <img src="assets/images/icons/product_single/Desc.png">
          </div>
          <div class="ml_16 bold_600 font_14">
            Отправим видео с вашим товаром
            перед доставкой
          </div>
        </div>
        <div class="add_basket_buttons">

          <button class="add_basket pointer" *ngIf="!data.countInBasket" (click)="addToBasket($event)">
            {{ 'product.single_page.add_to_basket' | translate }}
          </button>
          <button class="buy_in_one_click pointer" *ngIf="!data.countInBasket" (click)="addToBasket($event, true)">
            {{ 'product.single_page.buy_in_one_click' | translate }}
          </button>
          <app-add-and-reduce *ngIf="data.countInBasket"
                              [productCard]="data"
                              [type]="addAndReduceTypeEnums.SINGLE_PAGE">
          </app-add-and-reduce>

        </div>
       </div>
    </div>
    <div class="flower_details_mobile">
      <div class="flex_between_align_center">
        <div class="price_and_sale">
          <div class="price">
            {{ (data.price | priceSpaces) + "₽" }}
          </div>

        </div>
        <app-bonus-display *ngIf="data.bonusAmount"
                           [bonus]="data.bonusAmount"
        ></app-bonus-display>
      </div>
      <div class="flex_between_align_center">
<!--        <div class="discount">-->
<!--          -25%-->
<!--        </div>-->
        <div class="flex_align_center">
          <app-delivery-info [data]="{value:'545' , useType: 'product', type: 'deliveryPrice'}">
          </app-delivery-info>
          <div class="delivery_time" *ngIf="(data.deliveryTime | millisecondsToMinutes) as delivery">
            <app-delivery-info [data]="{value: (delivery | priceSpaces), useType: 'product', type: 'deliveryTime'}">
            </app-delivery-info>
          </div>
        </div>
      </div>
      <div class="name_and_description">
        <div class="name">
          {{data.title}}
        </div>
        <div class="description" [class.showAll]="showFullDescription">
          {{data.description}}
        </div>
        <div class="read_full_description pointer" *ngIf="!showFullDescription" (click)="showFullDescription = true">
          {{'product.single_page.read_full_description' | translate}}
        </div>
      </div>
      <div class="pictures_and_ratings mt_16">
        <div class="flex_between_align_center">
          <div class="flex_column">
            <div class="product_rating flex_align_center">
              <img src="assets/images/icons/shops/star_for_shop.svg">
              <div class="rating_number ml_8">
                {{data.productAverageRate | number: '0.2-2' | replaceToComma}}
              </div>
            </div>
            <div class="rate_count mt_8">
              {{ data.rateCount }} оценок
            </div>
          </div>
          <div class="flex_between_align_center photos pointer" *ngIf="reviewImages.length"
               (click)="openReviews()"
          >
            <div class="gallery">
              <ng-container *ngFor="let img of reviewImages; let i = index">
                <div class="image-wrapper" [ngClass]="{
                   margin_unset: i === 0,
                   last: (reviewImages.length > 5 && reviewImages.length - 1)
               }" >
                  <img [src]="img" />

                  <div class="overlay" *ngIf="reviewImages.length > 5">
                    +{{ data.rateResourcesCount }}
                  </div>
                </div>
              </ng-container>
            </div>
            <img src="assets/images/icons/chevron-right.svg">
          </div>
        </div>
        <div class="flex_align_center mt_16 banner_mobile">
          <div class="camera_block">
            <img src="assets/images/icons/product_single/Desc.png">
          </div>
          <div class="ml_12 bold_600 middle_small_text">
            Отправим видео с вашим товаром
            перед доставкой
          </div>
        </div>
      </div>
      <div class="shop_info flex_between_align_center mt_16 pointer"
        (click)="goToShopDetailsPage()"
      >
        <div>
          <div class="flex_align_center">
            <div class="shop_logo" [ngClass]="{'default_image flex_center_align_center':!data.shop.imageUrl}">
              <img [src]="data.shop.imageUrl || 'assets/images/icons/shops/shop-default.svg'"
                   [ngClass]="{'logo_img':data.shop.imageUrl}">
            </div>
            <div class="flex_column ml_12">
            <span class="text_normal_sub bold_700">
              {{ data.shop.shopName }}
            </span>
              <span class="shop_description">
                {{ data.shop?.description }}
            </span>
            </div>
          </div>
          <div class="flex_align_center mt_12">
            <div class="rating_number flex_align_center">
              <img src="assets/images/icons/shops/star_for_shop.svg">
              <span class="ml_4">
              {{data.shop.shopAverageRate | number: '0.2-2' | replaceToComma}}
            </span>
            </div>
            <div class="points_up_to flex_align_center ml_4">
            <span>
              Баллами до {{data.shop.bonusDeduction}}%
            </span>
              <img class="ml_4" src="assets/images/icons/bonus_icon_from_product_card.svg">
            </div>
          </div>
        </div>
        <img src="assets/images/icons/chevron-right.svg">
      </div>
    </div>
    <div class="other_products_in_the_store" *ngIf="isBrowser">
      <div class="flex_between_align_center">
        <div class="title">
          {{ 'product.single_page.other_products_in_the_store' | translate }}
        </div>
        <div class="flex_align_center see_all_button pointer">
          <span class="see_all">
            {{ 'sections.see_all' | translate }}
          </span>
          <img class="ml_4" src="assets/images/icons/product_single/arrow-right-orange.svg">
        </div>
      </div>
      <app-popular-products
        [prodSingle]="true"
        [productId]="data.id"
       >
      </app-popular-products>
    </div>
    <div class="bottom_banner">
      <img src="assets/images/icons/product_single/product_single_banner.svg">
    </div>
  </div>
  <div class="mobile_buy_buttons">
    <button class="add_basket pointer" *ngIf="!data.countInBasket" (click)="addToBasket($event)">
      {{ 'product.single_page.add_to_basket' | translate }}
    </button>
    <button class="buy_in_one_click pointer" *ngIf="!data.countInBasket" (click)="addToBasket($event, true)">
      {{ 'product.single_page.buy_in_one_click' | translate }}
    </button>
    <app-add-and-reduce class="w_100" *ngIf="data.countInBasket"
                        [productCard]="data"
                        [type]="addAndReduceTypeEnums.SINGLE_PAGE"
    >
    </app-add-and-reduce>

  </div>
</div>

<app-product-and-shop-reviews *ngIf="isMobile && reviewOpened"
                              [fromDialog]="false"
                              [data]="{shop: data.shop, product: data}"

></app-product-and-shop-reviews>
